import { render, staticRenderFns } from "./ClientesConecta.vue?vue&type=template&id=187ac5ec&"
import script from "./ClientesConecta.vue?vue&type=script&lang=ts&"
export * from "./ClientesConecta.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('187ac5ec', component.options)
    } else {
      api.reload('187ac5ec', component.options)
    }
    module.hot.accept("./ClientesConecta.vue?vue&type=template&id=187ac5ec&", function () {
      api.rerender('187ac5ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Clientes/ClientesConecta.vue"
export default component.exports